import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
export const SearchComponentItem = (props) => {
    const { group_name, value } = props;
    const navigate = useNavigate();
    const UrlNavigate = useCallback((group_name, source_name, id) => {
        navigate(`/settings/${group_name}/${source_name}`, {
            state: { item_id: id, key: source_name },
        });
    }, []);
    return (_jsx(List, { disablePadding: true, children: Object.entries(value).map(([source_name, array]) => {
            return (array.length > 0 &&
                array.map((el) => (_jsx(ListItem, { onClick: () => UrlNavigate(group_name, source_name, el.id), disablePadding: true, sx: (theme) => ({
                        transitionProperty: 'background-color, color',
                    }), children: _jsx(ListItemButton, { children: _jsx(ListItemText, { primary: el.name }) }) }, el.id))));
        }) }));
};
